module.exports = __webpack_public_path__ + "static/media/18ECA24.14c3d4dc.jpg";